import Vue from "vue";
import { isObject, isBoolean } from "util";

export default {
  //signUserUp (state, payload) { }, // DISABLED
  setLayout(state, payload) {
    state.layout = payload;
  },
  setUser(state, payload) {
    state.user = payload;
  },
  setAlert(state, payload) {
    state.alert = payload;
  },
  setPersonaBusqueda(state, payload) {
    state.personaBusqueda = payload;
  },
  setListaPersonas(state, payload) {
    state.listaPersonas = payload;
  },
  setUiConfig(state, payload) {
    state.UiConfig = payload;
  },
  setUiSettings(state, payload) {
    state.UiCustomUserSettings = payload;
  },
  setLoading(state, payload) {
    state.loading = payload;
  },
  setShowDialog(state, payload) {
    state.showDialog = payload;
  },
  setError(state, payload) {
    state.error = payload;
  },
  setDebugMode(state, payload) {
    state.debugModeOn = payload;
  },

  setParametrosGenerales(state, payload) {
    state.parametrosGenerales = payload;
  },
  logout(state) {
    state.user = null;
    state.UiConfig = null;
    state.loading = false;
    state.alert.show = false;
  },
  setLocale(state, locale) {
    localStorage.setItem("locale", locale);
    state.locale = locale;
  },
  setAmbiente(state, ambiente) {
    //localStorage.setItem('ambiente', ambiente)
    state.ambiente = ambiente;
  },
  async setActiveTask(state, payload) {
    //  console.log('task: ')
    //  console.log(payload.task)
    // console.log('props: ')
    // console.log(payload.props)

    state.activeTask = payload.task;
    state.activeTaskProps = payload.props;
    state.showActiveTask = true;
  },
  async hideActiveTask(state, closeRelatedTasks) {
    // console.log('cerrarRelacionados: ')
    // console.log(closeRelatedTasks)

    state.activeTask = null;
    state.activeTaskProps = null;
    state.showActiveTask = false;

    if (isBoolean(closeRelatedTasks))
      state.closeRelatedTasks = closeRelatedTasks;
    else state.closeRelatedTasks = false;
    // console.log('state.closeRelatedTasks: ')
    // console.log(state.closeRelatedTasks)
  },
  async setActiveSubTask(state, payload) {
    // console.log('sub-task: ')
    // console.log(payload.task)
    // console.log('props: ')
    // console.log(payload.props)
    state.activeSubTask = payload.task;
    state.activeSubTaskProps = payload.props;
    state.showActiveSubTask = true;
  },
  async hideActiveSubTask(state) {
    state.activeSubTask = null;
    state.activeSubTaskProps = null;
    state.showActiveSubTask = false;
  },
  // alerts
  alertClear(state) {
    state.alert.show = false;
  },
  alertSuccess(state, text) {
    state.alert.type = "success";
    state.alert.text = text;
    state.alert.show = true;
    setTimeout(() => (state.alert.show = false), 2000);
  },
  alertWarning(state, text) {
    state.alert.type = "warning";
    state.alert.text = text;
    state.alert.show = true;
    state.alert.dismissible = true;
    setTimeout(() => {
      state.alert.show = false;
    }, 3000);
  },
  alertValidationError(state, obj) {
    Vue.$log.error(text); // Logueo el error
    state.alert.type = "warning";
    let text = "";
    for (let key in obj) {
      text +=
        "<div><strong>" + key + ": </strong>" + obj[key].join(", ") + "</div>";
    }
    state.alert.text = text;
    state.alert.show = true;
    setTimeout(() => (state.alert.show = false), 4000);
  },
  alertError(state, error) {
    Vue.$log.error(error); // Logueo el error

    let text = "";
    let errorValidacion = false;

    if (isObject(error)) {
      text = error.ExceptionMessage;

      if (error.ValidationErrors) {
        for (let key in error.ValidationErrors) {
          text +=
            "<div><strong>" +
            error.ValidationErrors[key].Field +
            ": </strong>" +
            error.ValidationErrors[key].Message +
            "</div>";
        }
        errorValidacion = true;
      }
    } else {
      // Es texto
      text = error;
    }

    state.alert.text = text;
    state.alert.show = true;
    state.alert.dismissible = true;

    if (errorValidacion) {
      state.alert.type = "warning";
      setTimeout(() => (state.alert.show = false), 6000);
    } else {
      state.alert.type = "error";
      setTimeout(() => (state.alert.show = false), 10000);
    }
  },
  setReporteActivo(state, payload) {
    state.reporteActivo = payload.reporte;
    state.parametrosReporte = payload.params;

    console.log(state.reporteActivo);
    console.log(state.parametrosReporte);
  },
};
